export class Variety {
  id: number;
  name: string;
  commodity: any;
  companyId: number;
  preferredProductsCountries: Array<string>;

  constructor() {
    this.id = null;
    this.name = null;
    this.commodity = null;
    this.companyId = null;
    this.preferredProductsCountries = null;
  }
}
